import React from 'react';
import { isLocalStaticImage, webpSrc } from '../lib/imageSrc';

/**
 * Renders <picture> with WebP when a local .webp sibling exists, else plain <img>.
 */
const OptimizedImage = ({
  src,
  alt,
  width,
  height,
  loading = 'lazy',
  fetchPriority,
  className,
  style,
  onClick,
}) => {
  if (!src) return null;

  const webp = webpSrc(src);
  const imgProps = {
    src,
    alt: alt || '',
    width,
    height,
    loading,
    decoding: 'async',
    className,
    style,
    onClick,
  };
  if (fetchPriority) {
    imgProps.fetchPriority = fetchPriority;
  }

  if (webp && isLocalStaticImage(src)) {
    return (
      <picture className={`block w-full h-full ${className || ''}`} style={style}>
        <source srcSet={webp} type="image/webp" />
        <img
          src={src}
          alt={alt || ''}
          width={width}
          height={height}
          loading={loading}
          decoding="async"
          fetchPriority={fetchPriority}
          className="w-full h-full object-cover"
          onClick={onClick}
        />
      </picture>
    );
  }

  return <img {...imgProps} />;
};

export default OptimizedImage;
